import React, { useState } from "react";
import {
  Button,
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  Drawer,
  Modal,
  Divider,
  CssBaseline,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Fade,
} from "@mui/material";
import { Menu } from "@mui/icons-material";
import { NavLink as Link } from "react-router-dom";
import HeaderLink from "./HeaderLink";
import { theme } from "../services/Theme";
import ContactPage from "../pages/ContactPage";
import HaasFabLogoFull from "../images/HaasFabLogoFull.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mdi/react";
import { mdiFacebookMessenger as MessengerIcon } from "@mdi/js";

const Header = ({ openSuccessMessage }) => {
  //const classes = useStyles();

  const [linksHovered, setLinksHovered] = useState(false);
  //eslint-disable-next-line
  const [activePathName, setActivePathName] = useState("");
  const getLinksHovered = (state) => {
    setLinksHovered(state);
  };
  const updateActivePathName = (name) => {
    setActivePathName(name);
  };
  const [drawerState, setDrawerState] = useState(false);
  const toggleDrawer = () => {
    setDrawerState(!drawerState);
  };
  const handleClick = (name) => {
    window.scrollTo(0, 0);
    setActivePathName(name);
    setDrawerState(false);
  };
  const [contactUsState, setContactUsState] = useState(false);
  const toggleContactForm = () => {
    setContactUsState(!contactUsState);
  };
  const closeContactForm = () => {
    setContactUsState(false);
  };

  const openInstagramPage = () => {
    window.open("https://www.instagram.com/haasfab_llc/", "_blank");
  };
  const openFacebookPage = () => {
    window.open("https://www.facebook.com/HaasFab-100925839159371", "_blank");
  };
  const openMessenger = () => {
    window.open("http://m.me/haasfab", "_blank");
  };
  const openEmailTo = () => {
    window.open("mailto:business@haasfab.com", "_self");
  };

  const mobileNavLinks = [
    { name: "Services", to: "/" },
    { name: "Gallery", to: "/gallery" },
    { name: "About", to: "/about" },
    { name: "Contact Us", to: "/contact" },
  ];

  const socialButtonSx = {
    color: theme.palette.text.light,
    backgroundColor: "rgba(0,0,0,0.16)",
    border: `1px solid ${theme.palette.divider}`,
    width: { xs: 44, sm: 46 },
    height: { xs: 44, sm: 46 },
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  };

  return (
    <Box
      sx={{ position: "fixed", width: "100vw", height: "64px", zIndex: 10000 }}
    >
      <CssBaseline />
      <AppBar
        position="static"
        sx={{ alignItems: "center", justifyContent: "center" }}
      >
        <Toolbar
          sx={{
            maxWidth: 1200,
            width: "100%",
            height: "64px",
            alignItems: "center",
            display: "flex",
            paddingTop: 0.65,
            justifyContent: { xs: "space-between", sm: "space-between" },
          }}
        >
          <Link to="/" style={{ textDecoration: "none", color: "white" }}           onClick={()=> {window.scrollTo(0,0)}}
>
            <img src={HaasFabLogoFull} height="56px" alt="haasfab_logo_full"/>
          </Link>
          <Box sx={{ display: { xs: "none", sm: "flex" } }}>
            <HeaderLink
              text="Services"
              path="/"
              setLinksHovered={getLinksHovered}
              linksHovered={linksHovered}
              setActivePathName={updateActivePathName}
            />
            <HeaderLink
              text="Gallery"
              path="/gallery"
              setLinksHovered={getLinksHovered}
              linksHovered={linksHovered}
              setActivePathName={updateActivePathName}
            />
            <HeaderLink
              text="About"
              path="/about"
              setLinksHovered={getLinksHovered}
              linksHovered={linksHovered}
              setActivePathName={updateActivePathName}
            />
          </Box>

          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{
              mr: 1,
              display: { xs: "flex", sm: "none" },
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: "12px",
              p: 1,
              backgroundColor: "rgba(0,0,0,0.16)",
            }}
            onClick={toggleDrawer}
          >
            <Menu />
          </IconButton>

          <Button
            sx={{
              justifySelf: "flex-end",
              display: { xs: "none", sm: "flex" },
            }}
            variant="contained"
            color="secondary"
            onClick={toggleContactForm}
          >
            Contact Us
          </Button>
          <Drawer
            anchor="right"
            open={drawerState}
            onClose={toggleDrawer}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                width: "min(86vw, 360px)",
                background: `linear-gradient(160deg, ${theme.palette.primary.main} 0%, ${theme.palette.background.default} 100%)`,
                color: theme.palette.text.light,
                borderLeft: `1px solid ${theme.palette.divider}`,
                boxShadow: "-20px 0 45px rgba(0,0,0,0.45)",
                backdropFilter: "blur(8px)",
                overflowX: "hidden",
              },
            }}
          >
            <Box
              sx={{
                alignItems: "stretch",
                justifyContent: "flex-start",
                width: "100%",
                minHeight: "100%",
                display: "flex",
                padding: { xs: 2, sm: 2.5 },
                flexDirection: "column",
                backgroundColor: "transparent",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2,
                  px: 0.5,
                }}
              >
                <Typography
                  sx={{
                    letterSpacing: 1.2,
                    fontSize: "0.82rem",
                    textTransform: "uppercase",
                    color: theme.palette.text.light,
                    opacity: 0.75,
                    fontWeight: 700,
                  }}
                >
                  Menu
                </Typography>
                <IconButton
                  onClick={toggleDrawer}
                  sx={{
                    ...socialButtonSx,
                    width: 38,
                    height: 38,
                  }}
                >
                  <CloseIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </Box>

              <List sx={{ width: "100%", py: 0 }}>
                {mobileNavLinks.map((item) => {
                  const isActive = activePathName === item.name;

                  return (
                    <ListItemButton
                      key={item.name}
                      component={Link}
                      to={item.to}
                      onClick={() => handleClick(item.name)}
                      className="noselect"
                      sx={{
                        borderRadius: 2,
                        px: 2,
                        py: 1.4,
                        mb: 1,
                        border: `1px solid ${theme.palette.divider}`,
                        backgroundColor: isActive
                          ? theme.palette.secondary.main
                          : "rgba(0,0,0,0.14)",
                        color: theme.palette.text.light,
                        "&:hover": {
                          backgroundColor: isActive
                            ? theme.palette.secondary.main
                            : "rgba(0,0,0,0.24)",
                        },
                      }}
                    >
                      <ListItemText
                        primary={item.name}
                        primaryTypographyProps={{
                          fontSize: { xs: "1.1rem", sm: "1.15rem" },
                          fontWeight: isActive ? 700 : 500,
                          letterSpacing: 0.2,
                        }}
                      />
                    </ListItemButton>
                  );
                })}
              </List>

              <Box
                sx={{
                  mt: "auto",
                  pt: 2,
                }}
              >
                <Divider sx={{ borderColor: theme.palette.divider, mb: 2 }} />
                <Stack direction="row" spacing={1.25} justifyContent="center">
                  <IconButton onClick={openFacebookPage} className="noselect" sx={socialButtonSx}>
                    <FacebookIcon sx={{ fontSize: 24 }} />
                  </IconButton>
                  <IconButton onClick={openMessenger} className="noselect" sx={socialButtonSx}>
                    <Icon path={MessengerIcon} size={1.08} />
                  </IconButton>
                  <IconButton onClick={openEmailTo} className="noselect" sx={socialButtonSx}>
                    <EmailIcon sx={{ fontSize: 24 }} />
                  </IconButton>
                  <IconButton onClick={openInstagramPage} className="noselect" sx={socialButtonSx}>
                    <InstagramIcon sx={{ fontSize: 24 }} />
                  </IconButton>
                </Stack>
              </Box>
            </Box>
          </Drawer>
          <Modal
            open={contactUsState}
            onClose={toggleContactForm}
            closeAfterTransition
            slotProps={{
              backdrop: {
                timeout: 220,
              },
            }}
          >
            <Fade in={contactUsState} timeout={220}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",

                  bgcolor: "background.paper",
                  border: "2px solid #000",
                  display: "flex",
                }}
              >
                <ContactPage
                  closeContactForm={closeContactForm}
                  openSuccessMessage={openSuccessMessage}
                />
              </Box>
            </Fade>
          </Modal>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

// const useStyles = makeStyles((theme) => ({
//   // This group of buttons will be aligned to the right
//   rightToolbar: {
//     marginLeft: "auto",
//     marginRight: -12,
//   },
//   menuButton: {
//     display: "none",
//     marginRight: 16,
//     marginLeft: -12,
//     [theme.breakpoints.down("sm")]: {
//       display: "flex",
//     },
//   },
//   linkContainer: {
//     display: "flex",
//     marginLeft: 50,
//     height: "100%",
//     [theme.breakpoints.down("sm")]: {
//       display: "none",
//     },
//   },
//   mobileCurrentLink: {
//     display: "none",
//     marginLeft: 50,
//     [theme.breakpoints.down("sm")]: {
//       display: "flex",
//     },
//   },
// }));

export default Header;
